@use "styles/abstracts/mixins/typography" as t;
@use "styles/abstracts/variables" as v;

.btn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 8px 24px;
    width: max-content;
    font-family: v.$primary-font;
    @include t.text(14px, 22px, 600);
    text-decoration: none;
    color: v.$default-text-color;
    border: none;
    border-radius: 8px;
    transition: v.$transition;
    cursor: pointer;

    svg path {
        transition: v.$transition;
    }

    &.disabled {
        background-color: v.$palette-dirty-50;
        pointer-events: none;
        user-select: none;
    }

    &.primary {
        color: v.$palette-white;
        background-color: v.$default-text-color;

        &.large {
            padding: 11px 24px;
            @include t.text(16px, 26px, 600);
        }

        &.active,
        &:active {
            background-color: v.$palette-dubai-80;
        }

        @media (pointer: fine) {
            &:hover {
                background-color: v.$palette-dubai-80;
            }
        }

        &.disabled {
            background-color: v.$palette-dirty-50;
        }
    }

    &.secondary {
        background-color: v.$palette-dirty-20;

        &.large {
            padding: 11px 24px;
            @include t.text(16px, 26px, 600);
        }

        &.active,
        &:active {
            color: v.$palette-orange-2;
            background-color: v.$palette-orange-4;

            svg path {
                fill: v.$palette-orange-2;
            }
        }

        @media (pointer: fine) {
            &:hover {
                color: v.$palette-orange-2;
                background-color: v.$palette-orange-4;

                svg path {
                    fill: v.$palette-orange-2;
                }
            }
        }

        &.disabled {
            color: v.$palette-dirty-50;
            background-color: v.$palette-dirty-20;

            svg path {
                fill: v.$palette-dirty-50;
            }
        }
    }

    &.tertiary {
        padding: 5px 16px;
        background-color: transparent;

        &.active,
        &:active {
            color: v.$palette-orange-2;
            background-color: v.$palette-orange-4;

            svg path {
                fill: v.$palette-orange-2;
            }
        }

        @media (pointer: fine) {
            &:hover {
                color: v.$palette-orange-2;
                background-color: v.$palette-orange-4;

                svg path {
                    fill: v.$palette-orange-2;
                }
            }
        }

        &.disabled {
            color: v.$palette-dirty-40;

            svg path {
                fill: v.$palette-dirty-40;
            }
        }
    }

    &.only-icon {
        padding: 6px;
        background-color: v.$palette-dirty-10;

        &.active,
        &:active {
            color: v.$palette-orange-2;
            background-color: v.$palette-orange-4;

            svg path {
                fill: v.$palette-orange-2;
            }
        }

        @media (pointer: fine) {
            &:hover {
                color: v.$palette-orange-2;
                background-color: v.$palette-orange-4;

                svg path {
                    fill: v.$palette-orange-2;
                }
            }
        }

        &.disabled {
            background-color: v.$palette-dirty-20;

            svg path {
                fill: v.$palette-dirty-50;
            }
        }
    }

    &.only-icon-transparent {
        padding: 6px;
        background-color: transparent;
        
        &.active,
        &:active {
            color: v.$palette-orange-2;
            background-color: transparent;

            svg path {
                fill: v.$palette-orange-2;
            }
        }

        @media (pointer: fine) {
            &:hover {
                color: v.$palette-orange-2;
                background-color: transparent;

                svg path {
                    fill: v.$palette-orange-2;
                }
            }
        }

        &.disabled {
            svg path {
                fill: v.$palette-dirty-50;
            }
        }
    }
}
